export class KnownErrorDuringOAUTHError extends Error {
  constructor(code: string) {
    super(`Ошибка во время авторизации: ${code}`)
  }
}